// extracted by mini-css-extract-plugin
export default {"list":"ProjectCartList_list__3v+-B"};